<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <BaseFieldString
            v-model="storeAggregate.rootData[storeDetail.uidItem].name"
            label="Name"
        ></BaseFieldString>
        <SimpleChildTable
            title="Embedded SimpleChildTable"
            :height="300"
            :items="storeAggregate.rootData[storeDetail.uidItem].simple_children_uid"
            store-name="SimpleChildTableEmbedded"
            detail-store-name="SimpleChildDetailEmbedded"
            dto-detail-query="SimpleChildDetailEmbeddedQueryDTO"
            @removemembers="removeMembers($event)"
        ></SimpleChildTable>
        <SimpleChildTable
            title="SimpleChildTable"
            :height="400"
            store-name="SimpleChildTable"
            @addmembers="addMembers($event)"
        ></SimpleChildTable>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import {useTableStore} from "@/components/Common/CommonTable";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import SimpleChildTable from "@/components/Common/Example/SimpleChildTable";

export default {
  name: "SimpleMainDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'SimpleMainDetail'},
    dtoDetailQuery: {default: 'SimpleDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'SimpleActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'SimpleSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'SimpleValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'SimpleMainBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'SimpleMainTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    BaseFieldString,
    CommonDetail,
    SimpleChildTable,
  },

  computed: {
  },

  methods: {
    filters_exclude_uid() {
      let exclude_uid = []
      if (!!this.storeDetail.uidItem && this.storeAggregate.rootData[this.storeDetail.uidItem])
        this.storeAggregate.rootData[this.storeDetail.uidItem].simple_children_uid.forEach(row => exclude_uid.push(row.uid))
      // console.log('filters_exclude_uid', exclude_uid)
      return exclude_uid
    },
    addMembers(item) {
      // console.log('addMembers', item, this.storeDetail.uidItem, this.storeAggregate.uid_dict[this.storeDetail.uidItem].simple_children_uid)
      // console.log('addMembers proxy', this.storeAggregate.rootData[this.storeDetail.uidItem].simple_children_uid)
      if (!this.storeAggregate.uid_dict[this.storeDetail.uidItem].simple_children_uid.includes(item.uid)) {
        let simple_children_uid = new Set()
        this.storeAggregate.rootData[this.storeDetail.uidItem].simple_children_uid.forEach(row => simple_children_uid.add(row.uid))
        simple_children_uid.add(item.uid)
        this.storeAggregate.rootData[this.storeDetail.uidItem].simple_children_uid = [...simple_children_uid]
        this.storeChildTable.setExcludeFilters([...simple_children_uid])
        this.storeChildTable.updateList()
      }
    },
    removeMembers(item) {
      // console.log('removeMembers', item, this.storeDetail.uidItem, this.storeAggregate.uid_dict[this.storeDetail.uidItem].simple_children_uid)
      // console.log('removeMembers proxy', this.storeAggregate.rootData[this.storeDetail.uidItem].simple_children_uid)
      if (this.storeAggregate.uid_dict[this.storeDetail.uidItem].simple_children_uid.includes(item.uid)) {
        let simple_children_uid = []
        for (let row of this.storeAggregate.rootData[this.storeDetail.uidItem].simple_children_uid) {
          if (row.uid !== item.uid)
            simple_children_uid.push(row.uid)
        }
        this.storeAggregate.rootData[this.storeDetail.uidItem].simple_children_uid = simple_children_uid
        this.storeChildTable.setExcludeFilters(simple_children_uid)
        this.storeChildTable.updateList()
      }
    },
  },


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeEmbeddedTable = useTableStore('SimpleChildTableEmbedded')()
    this.storeEmbeddedTable.options.itemsPerPage = -1
    this.storeEmbeddedTable.footerProps = {'items-per-page-options': [-1]}
    this.storeAggregate = useAggregateStore()
    this.storeChildTable = useTableStore('SimpleChildTable')()
    this.storeChildTable.filters['exclude_uid'] = this.filters_exclude_uid()
  },

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      storeChildTable: null,
      storeEmbeddedTable: null,
    }
  },
}
</script>

<style scoped>

</style>